import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDao } from './BaseDao';

export class RoleDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.ROLE, apiHelper);
  }
}
